export const TPA_EXPERIMENTS = {
  INSTALL_ECOM: 'specs.membership.InstallEcom',
  ECOM_INTEGRATION_ENABLED: 'specs.membership.EcomIntegrationEnabled',
  DESIGN_SYSTEM_SETTINGS_MIGRATION: 'specs.membership.DesignSystemSettingsMigration',
  BREAKPOINT_INDICATORS_OOI: 'specs.membership.breakpointIndicatorsOOI',
  ADD_PLAN_COVER_IMAGE: 'specs.membership.AddPlanCoverImage',
  RENDER_PLAN_COVER_IMAGE: 'specs.membership.RenderPlanCoverImage',
  BENEFIT_PROGRAMS_ENABLED: 'specs.membership.BenefitProgramsEnabled',
  BLOCKS_BUTTON_LOADER: 'specs.membership.BlocksButtonLoader',
  FIX_MOBILE_CHECKOUT: 'specs.membership.FixMobileCheckout',
  USE_SERVERLESS_FOR_EIE: 'specs.membership.UseServerlessForEIE',
  // ECOM_INTEGRATION_ENABLED
  ERROR_HANDLER_TPA: 'specs.membership.ErrorHandlerTpa',
  ECOM_GEOIP_ADDRESS: 'specs.membership.EcomGeoIpAddress',
  HOVER_STYLE_UNDERLINE: 'specs.membership.HoverStyleUnderline',
  PERKS_ARROW_FOCUS_FIX: 'specs.membership.PerksArrowFocusFix',
  SETTINGS_EVENTS_FIX: 'specs.membership.SettingsEventsFix',
  BUTTON_HOVER_SETTINGS_EDITOR: 'specs.membership.ButtonHoverSettingsEditor',
  BUTTON_HOVER_SETTINGS_VIEWER: 'specs.membership.ButtonHoverSettingsViewer',
  PLAN_LIST_V2: 'specs.membership.PlanListV2',
  CHECKOUT_TRIGGER_ON_LOGIN_ONCE: 'specs.membership.CheckoutTriggerOnLoginOnce',
  SUGGEST_ECOM_MIGRATION: 'specs.pricingPlans.SuggestEcomMigration',
  AUTOINSTALL_ECOM_PAGES: 'specs.PricingPlans.AutoinstallMissingEcomPages',
  IMPROVE_ECOM_LOADING_STATE: 'specs.PricingPlans.ImproveEcomLoadingState'
};
//# sourceMappingURL=tpa.js.map